import * as React from "react";
import HelpedTextField from "./helped_text_field";

export default function HelpedAdornedTextField({ adornment, ...props }) {
  return <HelpedTextField InputProps={{ endAdornment: adornment }} {...props} />;
}
